import { render, staticRenderFns } from "./roomStatus.vue?vue&type=template&id=2d3de6d2&scoped=true"
import script from "./roomStatus.vue?vue&type=script&lang=js"
export * from "./roomStatus.vue?vue&type=script&lang=js"
import style0 from "./roomStatus.vue?vue&type=style&index=0&id=2d3de6d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3de6d2",
  null
  
)

export default component.exports